import React, {Component, ReactElement, ReactNode} from 'react'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import {NatGetRoomToResidentDetails} from '../roomToResident/repository/NatGetRoomToResidentDetails'
import {
    NatPutRoomToResidentActivation,
    NatPutRoomToResidentActivationParams,
} from '../roomToResident/repository/NatPutRoomToResidentActivation'
import {
    ADMINISTORATOR_MODE,
    APPLY_STATUS,
    AVAILABLE_OR_NOT,
    HAVE_OR_NOT,
    MAIL_MAGAZINE_RECEIVING_DO_OR_NOT,
    MESSAGE_TYPE,
    NOTIFICATION_DO_OR_NOT,
    RESIDENT_STATUS,
    ROLE_FOR_ADMINISTRATOR,
    SEX_MASTER,
} from '../../../CodeMaster'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Messages} from '../../../Messages'
import {Nullable} from '../../../app/TypeHelpers'
import {StyledTableCaption, TableRowName, TableRowNameTop} from '../../../styledComponents/adminPage/Table'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, DeleteLink, StyledLink} from '../../../styledComponents/adminPage/Links'
import {formatDateZeroPadding} from '../../../formatters/formatDate'
import {Box, Table, TableBody, TableCell, TableRow} from '@mui/material';
import AuthorityChecker from '../../../components/AuthorityChecker'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {HKConstants} from '../../../HKConstants'
import {
    DeleteRoomToResidentRequest,
    NatDeleteRoomToResident,
} from '../roomToResident/repository/NatDeleteRoomToResident'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {NatGetCondominium} from '../condominium/repository/NatGetCondominium'
import {
    getAcceptedWarningList,
    getStringOrEmptyString,
    needsMaskConfidentialDataByLoginUser,
    setHighlightingWarningList,
} from '../../common/util/Natutil'
import NatPrintDialogComponent, {PRINT_TYPE} from '../common/NatPrintDialogComponent'
import {
    NatGetRoomToResidentAuthKeyNoticeData,
} from '../roomToResident/repository/NatGetRoomToResidentAuthKeyNoticeData'
import {
    NatPutRoomToResidentNoticeIssueDone,
    NatPutRoomToResidentNoticeIssueDoneParams,
} from '../roomToResident/repository/NatPutRoomToResidentNoticeIssueDone'
import {createRejectionResidentUserRegistrationApplyInfoMessage} from './NatAdminResidentUserHelper'
import {NatRejectionRegistrationApplyInfo} from '../roomToResident/repository/NatRejectionRegistrationApplyInfo'
import {
    NatPutRoomToResidentAbolitionReset,
    NatPutRoomToResidentAbolitionResetParams,
} from '../roomToResident/repository/NatPutRoomToResidentAbolitionReset'
import {AcceptedWarning, Warning} from '../common/admin/NatAcceptedWarning'
import NatAdminCommonAcceptedWarningComponent from '../common/admin/NatAdminCommonAcceptedWarningComponent'
import {TransitionDestinationInfo} from './admin/NatTransitionDestinationInterface'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import moment from 'moment'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {
    AdminLoginInfoSessionStorageKey,
    NatAdminLoginInfoSessionStorageHelper,
} from '../../common/authentication/NatAdminLoginInfoSessionStorageHelper'
import {Location} from 'react-router-dom'

const KEY_SEARCH_CONDITION: string = 'adminFacilityReserveListPageSearchCondition'

const highlightingMessegIdList: string[] = [Messages.WRESA0006.id]

interface Props {
    condominiumCd: string
    ridgeCd: string
    roomNumber: string
    seq: string
    roomToResidentRepo: NatRoomToResidentRepo
    condominiumRepo: NatCondominiumRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    roomToResidentDetails: NatGetRoomToResidentDetails
    mainUserFlag: boolean
    unRegisteredFlag: boolean
    isLoadCompleted: boolean
    activationButtonDisabled: boolean
    activation: boolean
    selectedCondominiumCardKey: string
    noticeIssueButtonDisabled: boolean
    noticeIssueOpen: boolean
    authKeyNoticeData: NatGetRoomToResidentAuthKeyNoticeData
    acceptAll: boolean
    currentDate: Nullable<moment.Moment>
    acceptedWarning: AcceptedWarning[]
    warnings: Warning[]
    abolitionResetExecutionFlg: boolean
}

export interface SearchCondition {
    userId?: string
    userRidgeCd?: string
    dispUserRidgeName?: string
    userRoomNumber?: string
    dispUserName?: string
    dispAdminUserName?: string
}

class NatAdminResidentUserDetailsPage extends Component<Props & AdminPagePropsSet, States> {
    administratorMode: Nullable<string>
    loginUserRoleId: Nullable<string>
    returnLinkInfo: TransitionDestinationInfo

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.administratorMode = NatAdminLoginInfoSessionStorageHelper
            .getStringItemOrNull(AdminLoginInfoSessionStorageKey.SELECTED_MODE)
        this.loginUserRoleId = NatAdminLoginInfoSessionStorageHelper
            .getStringItemOrNull(AdminLoginInfoSessionStorageKey.LOGIN_USER_ROLE_ID)
        this.returnLinkInfo = (this.props.location.state && this.props.location.state.returnLinkInfo)
            ? this.props.location.state.returnLinkInfo
            : {label: '居住者ユーザ検索へ戻る', url: '/admin/residentUserList'}

        let activation: boolean = false
        let abolitionResetExecutionFlg: boolean = false
        if (this.props.location && this.props.location.state) {
            if (this.props.location.state.activation) {
                activation = true
                this.props.navigate(this.props.location.pathname, {
                    state: {
                        activation: false,
                    },
                })
            }
            if (this.props.location.state.abolitionResetExecutionFlg) {
                abolitionResetExecutionFlg = true
                this.props.navigate(this.props.location.pathname, {
                    state: {
                        abolitionResetExecutionFlg: false,
                    },
                })
            }
        }

        this.state = {
            roomToResidentDetails: {
                details: null,
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            mainUserFlag: false,
            unRegisteredFlag: false,
            isLoadCompleted: false,
            activationButtonDisabled: false,
            activation: activation,
            selectedCondominiumCardKey: HAVE_OR_NOT.NOT.value,
            noticeIssueButtonDisabled: false,
            noticeIssueOpen: false,
            authKeyNoticeData: {
                details: null,
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            acceptAll: false,
            currentDate: null,
            acceptedWarning: [],
            warnings: [],
            abolitionResetExecutionFlg: abolitionResetExecutionFlg,
        }
        this.editResidentUserLinkClick = this.editResidentUserLinkClick.bind(this)
        this.editResidentUserForAdminNameLinkClick = this.editResidentUserForAdminNameLinkClick.bind(this)
        this.facilityReservationLinkClick = this.facilityReservationLinkClick.bind(this)
        this.activationResidentUser = this.activationResidentUser.bind(this)
        this.deleteResidentUser = this.deleteResidentUser.bind(this)
        this.handleActivationResidentUserOkClick = this.handleActivationResidentUserOkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleDeleteOkClick = this.handleDeleteOkClick.bind(this)
        this.handleNoticeIssueCancelClick = this.handleNoticeIssueCancelClick.bind(this)
        this.noticeIssueClick = this.noticeIssueClick.bind(this)
        this.handleNoticeIssuePrintClick = this.handleNoticeIssuePrintClick.bind(this)
        this.onChangeAcceptedWarnings = this.onChangeAcceptedWarnings.bind(this)
        this.onClickAbolitionReset = this.onClickAbolitionReset.bind(this)
        this.handleAbolitionResetOkClick = this.handleAbolitionResetOkClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 部屋居住者取得
            const roomToResidentDetails: Nullable<NatGetRoomToResidentDetails> = await this.props.asyncCallFunction(
                this.props.roomToResidentRepo.getRoomToResidentDetails.bind(this.props.roomToResidentRepo,
                    this.props.condominiumCd, this.props.ridgeCd, this.props.roomNumber, this.props.seq),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (roomToResidentDetails && roomToResidentDetails.details) {
                const mainUserFlag: boolean = roomToResidentDetails.details.parentResidentId ? false : true
                const unRegisteredFlag: boolean = (roomToResidentDetails.details.sutekiNetId === '' ||
                    roomToResidentDetails.details.sutekiNetId === null)

                this.setState({
                    roomToResidentDetails: roomToResidentDetails,
                    mainUserFlag: mainUserFlag,
                    unRegisteredFlag: unRegisteredFlag,
                    isLoadCompleted: true,
                })
            }
            const condominiumResponse: Nullable<NatGetCondominium> = await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominium.bind(
                    this.props.condominiumRepo, this.props.condominiumCd,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (condominiumResponse && condominiumResponse.details) {
                this.setState({
                    selectedCondominiumCardKey: condominiumResponse.details.cardKey,
                })
            }
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (currentDateTime && currentDateTime.details) {
                this.setState({
                    currentDate: moment(currentDateTime.details.currentDateTime, 'YYYY-MM-DD'),
                })
            }

            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        } else if (this.state.activation) {
            this.setState({activation: false})
            const activationMessage: HeadingAreaMessageParams = {
                title: null,
                messageLevel: MESSAGE_TYPE.INFORMATION,
                detail: Messages.IRESA0010.toString(''),
            }
            this.props.eventEmitter.showHeadingAreaMessage(activationMessage)
            return
        } else if (this.state.abolitionResetExecutionFlg) {
            this.setState({abolitionResetExecutionFlg: false})
            const noticeApplyMessage: HeadingAreaMessageParams = {
                title: null,
                messageLevel: MESSAGE_TYPE.INFORMATION,
                detail: Messages.IRESA0036.toString(''),
            }
            this.props.eventEmitter.showHeadingAreaMessage(noticeApplyMessage)
            return
        }

        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    facilityReservationLinkClick(): void {
        if (this.state.roomToResidentDetails && this.state.roomToResidentDetails.details) {

            // 氏名
            let dispUserName: string = ''
            if (this.state.roomToResidentDetails.details.familyName) {
                dispUserName = this.state.roomToResidentDetails.details.familyName
                if (this.state.roomToResidentDetails.details.firstName) {
                    dispUserName = dispUserName +
                        ' ' + this.state.roomToResidentDetails.details.firstName
                }
            } else if (this.state.roomToResidentDetails.details.firstName) {
                dispUserName = this.state.roomToResidentDetails.details.firstName
            }

            // 管理者確認用氏名
            let dispAdminUserName: string = ''
            if (this.state.roomToResidentDetails.details.adminFamilyName) {
                dispAdminUserName = this.state.roomToResidentDetails.details.adminFamilyName
                if (this.state.roomToResidentDetails.details.adminFirstName) {
                    dispAdminUserName = dispAdminUserName +
                        ' ' + this.state.roomToResidentDetails.details.adminFirstName
                }
            } else if (this.state.roomToResidentDetails.details.adminFirstName) {
                dispAdminUserName = this.state.roomToResidentDetails.details.adminFirstName
            }

            const searchCondition: SearchCondition = {
                userId: this.state.roomToResidentDetails.details.sutekiNetId,
                userRidgeCd: this.state.roomToResidentDetails.details.ridgeCd,
                dispUserRidgeName: this.state.roomToResidentDetails.details.ridgeName,
                userRoomNumber: this.state.roomToResidentDetails.details.roomNumber,
                dispUserName: dispUserName,
                dispAdminUserName: dispAdminUserName,
            }
            SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(searchCondition))
            this.props.navigate(`/admin/facilityReserveList`)
        }
    }

    editResidentUserLinkClick(): void {
        this.props.navigate(`/admin/residentUserEdit/${this.props.condominiumCd}/${this.props.ridgeCd}/${this.props.roomNumber}/${this.props.seq}`)
    }

    editResidentUserForAdminNameLinkClick(): void {
        this.props.navigate(`/admin/residentUserEditForAdminName/${this.props.condominiumCd}/${this.props.ridgeCd}/${this.props.roomNumber}/${this.props.seq}`)
    }

    // 削除ボタン押下
    async deleteResidentUser(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0011.errorLevel,
                message: Messages.IOPCC0011.toString('居住者ユーザ'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleDeleteOkClick,
                    },
                ],
            },
        )
    }

    // 廃止取消ボタン押下
    async onClickAbolitionReset(): Promise<void> {
        let message: Messages = Messages.IRESA0037
        if (this.state.roomToResidentDetails.details?.validPeriodEndDate !== null) {
            const currentDate = this.state.currentDate!.clone()
            const validPeriodEndDate = moment(
                this.state.roomToResidentDetails.details?.validPeriodEndDate, 'YYYY-MM-DD')
            if (validPeriodEndDate.isBefore(currentDate)) {
                message = Messages.IRESA0038
            }
        }
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: message.errorLevel,
                message: message.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleAbolitionResetOkClick,
                    },
                ],
            },
        )
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    handleNoticeIssueCancelClick(): void {
        this.setState({noticeIssueOpen: false})
    }

    async handleNoticeIssuePrintClick(): Promise<void> {
        try {
            if (this.state.roomToResidentDetails && this.state.roomToResidentDetails.details) {
                const request: NatPutRoomToResidentNoticeIssueDoneParams = {
                    condominiumCd: this.props.condominiumCd,
                    ridgeCd: this.props.ridgeCd,
                    roomNumber: this.props.roomNumber,
                    seq: Number(this.props.seq),
                    noticeApplyVersion: this.state.roomToResidentDetails.details.noticeApplyVersion,
                    roomToResidentVersion: this.state.roomToResidentDetails.details.roomToResidentVersion,
                }
                // 通知状発行完了
                const response: Nullable<NatPutRoomToResidentNoticeIssueDone> = await this.props.asyncCallFunction(
                    this.props.roomToResidentRepo.putAuthKeyNoticeIssueDone.bind(
                        this.props.roomToResidentRepo, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                )
                if (response && response.requestError === null) {
                    window.location.reload()
                } else {
                    return
                }
            }
        } finally {
            this.setState({noticeIssueOpen: false})
        }
    }

    async handleDeleteOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        try {
            if (this.state.roomToResidentDetails &&
                this.state.roomToResidentDetails.details) {
                // 居住者ユーザ削除
                const request: DeleteRoomToResidentRequest = {
                    condominiumCd: this.state.roomToResidentDetails.details.condominiumCd,
                    ridgeCd: this.state.roomToResidentDetails.details.ridgeCd,
                    roomNumber: this.state.roomToResidentDetails.details.roomNumber,
                    seq: this.state.roomToResidentDetails.details.seq,
                }
                if (this.state.acceptedWarning.length > 0) {
                    request.permissionWarning = this.state.acceptedWarning
                }
                const ret: Nullable<NatDeleteRoomToResident> = await this.props.asyncCallFunction(
                    this.props.roomToResidentRepo.deleteRoomToResident.bind(this.props.roomToResidentRepo, request),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
                if (ret !== null && ret.requestError === null) {
                    if (ret.informations !== null) {
                        this.setState({warnings: getAcceptedWarningList(ret.informations)})
                    } else {
                        let detailMessage: string = Messages.IOPCC0009.toString('居住者ユーザ')
                        if (ret.details !== null && ret.details.rejectionRegistrationApplyInfo !== null) {
                            const rejectionRegistrationApplyInfo: NatRejectionRegistrationApplyInfo[] = []
                            rejectionRegistrationApplyInfo.push(ret.details.rejectionRegistrationApplyInfo)
                            const rejectionResidentUserRegistrationApplyInfoListMessage: string =
                                createRejectionResidentUserRegistrationApplyInfoMessage(
                                    rejectionRegistrationApplyInfo)
                            const addDetailMessage = '\n' + rejectionResidentUserRegistrationApplyInfoListMessage
                            detailMessage = detailMessage + addDetailMessage
                        }
                        this.props.navigate(`/admin/residentUserList`,
                            {
                                state: {
                                    initialMessage: {
                                        title: null,
                                        messageLevel: MESSAGE_TYPE.INFORMATION,
                                        detail: detailMessage,
                                    },
                                },
                            },
                        )
                    }
                } else {
                    return
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleAbolitionResetOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        try {
            if (this.state.roomToResidentDetails && this.state.roomToResidentDetails.details) {
                const request: NatPutRoomToResidentAbolitionResetParams = {
                    condominiumCd: this.props.condominiumCd,
                    ridgeCd: this.props.ridgeCd,
                    roomNumber: this.props.roomNumber,
                    seq: Number(this.props.seq),
                }
                // 部屋居住者廃止取消
                const response: Nullable<NatPutRoomToResidentAbolitionReset> = await this.props.asyncCallFunction(
                    this.props.roomToResidentRepo.putRoomToResidentAbolitionReset.bind(
                        this.props.roomToResidentRepo, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                )
                if (response && response.requestError === null) {
                    this.props.navigate(this.props.location.pathname, {
                        state: {
                            abolitionResetExecutionFlg: true,
                        },
                    })
                    window.location.reload()
                } else {
                    return
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // 有効化ボタン押下
    async activationResidentUser(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IRESA0009.errorLevel,
                message: Messages.IRESA0009.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleActivationResidentUserOkClick,
                    },
                ],
            },
        )
    }


    // 通知状発行ボタン押下
    async noticeIssueClick(): Promise<void> {
        try {
            // 通知状内のデータを取得
            const response: Nullable<NatGetRoomToResidentAuthKeyNoticeData> = await this.props.asyncCallFunction(
                this.props.roomToResidentRepo.getAuthKeyNoticeData.bind(this.props.roomToResidentRepo,
                    this.props.condominiumCd, this.props.ridgeCd, this.props.roomNumber, this.props.seq),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (response && response.details) {
                this.setState({
                    authKeyNoticeData: response,
                    noticeIssueOpen: true,
                })
            }
        } finally {
        }
    }

    async handleActivationResidentUserOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        // 2重送信対応のため、有効化ボタンを非表示にする
        this.setState({activationButtonDisabled: true})

        try {
            if (this.state.roomToResidentDetails &&
                this.state.roomToResidentDetails.details) {
                const request: NatPutRoomToResidentActivationParams = {
                    condominiumCd: this.props.condominiumCd,
                    ridgeCd: this.props.ridgeCd,
                    roomNumber: this.props.roomNumber,
                    seq: Number(this.props.seq),
                    roomToResidentVersion: this.state.roomToResidentDetails.details.roomToResidentVersion,
                }
                // 居住者ユーザ更新
                const response: Nullable<NatPutRoomToResidentActivation> = await this.props.asyncCallFunction(
                    this.props.roomToResidentRepo.putRoomToResidentActivation.bind(
                        this.props.roomToResidentRepo, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                )
                if (response &&
                    response.requestError === null) {
                    this.props.navigate(this.props.location.pathname, {
                        state: {
                            activation: true,
                        },
                    })
                    window.location.reload()
                } else {
                    return
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    onChangeAcceptedWarnings(acceptAll: boolean, acceptedWarning: AcceptedWarning[]): void {
        this.setState({
            acceptAll: acceptAll,
            acceptedWarning: acceptedWarning,
        })
    }

    renderInputFormTable(): ReactNode {
        if (this.state.roomToResidentDetails && this.state.roomToResidentDetails.details) {
            const residentStatusCode =
                RESIDENT_STATUS.codeToEnumConstants(
                    this.state.roomToResidentDetails.details.residentStatus,
                )

            let sexLabel: string = ''
            if (this.state.roomToResidentDetails.details.sex) {
                if (needsMaskConfidentialDataByLoginUser()) {
                    sexLabel = this.state.roomToResidentDetails.details.sex
                } else {
                    const sexCode =
                        SEX_MASTER.codeToEnumConstants(
                            this.state.roomToResidentDetails.details.sex,
                        )
                    sexLabel = sexCode.label
                }
            }

            let birthday: string = ''
            if (this.state.roomToResidentDetails.details.birthday) {
                if (needsMaskConfidentialDataByLoginUser()) {
                    birthday = this.state.roomToResidentDetails.details.birthday
                } else {
                    birthday = formatDateZeroPadding(this.state.roomToResidentDetails.details.birthday)
                }
            }

            let validPeriodStartDate: string = ''
            if (this.state.roomToResidentDetails.details.validPeriodStartDate) {
                validPeriodStartDate =
                    formatDateZeroPadding(this.state.roomToResidentDetails.details.validPeriodStartDate)
            }
            let validPeriodEndDate: string = ''
            if (this.state.roomToResidentDetails.details.validPeriodEndDate) {
                validPeriodEndDate =
                    formatDateZeroPadding(this.state.roomToResidentDetails.details.validPeriodEndDate)
            }

            let sutekiNetOfNoticeLabel: string = ''
            if (this.state.roomToResidentDetails.details.sutekiNetOfNotice) {
                const sutekiNetOfNoticeCode =
                    MAIL_MAGAZINE_RECEIVING_DO_OR_NOT.codeToEnumConstants(
                        this.state.roomToResidentDetails.details.sutekiNetOfNotice,
                    )
                sutekiNetOfNoticeLabel = sutekiNetOfNoticeCode.label
            }

            let bulletinBoardCommentNoticeLabel: string = ''
            if (this.state.roomToResidentDetails.details.bulletinBoardCommentNotice) {
                const bulletinBoardCommentNoticeCode =
                    NOTIFICATION_DO_OR_NOT.codeToEnumConstants(
                        this.state.roomToResidentDetails.details.bulletinBoardCommentNotice,
                    )
                bulletinBoardCommentNoticeLabel = bulletinBoardCommentNoticeCode.label
            }

            let billingAmountFixNoticeLabel: string = ''
            if (this.state.roomToResidentDetails.details.billingAmountFixNotice) {
                const billingAmountFixNoticeCode =
                    NOTIFICATION_DO_OR_NOT.codeToEnumConstants(
                        this.state.roomToResidentDetails.details.billingAmountFixNotice,
                    )
                billingAmountFixNoticeLabel = billingAmountFixNoticeCode.label
            }

            let facilityReserveAvailabilityLabel: string = ''
            if (this.state.roomToResidentDetails.details.facilityReserveAvailability) {
                const facilityReserveAvailabilityCode =
                    AVAILABLE_OR_NOT.codeToEnumConstants(
                        this.state.roomToResidentDetails.details.facilityReserveAvailability,
                    )
                facilityReserveAvailabilityLabel = facilityReserveAvailabilityCode.label
            }

            let noticeIssueLabel: string = ''
            if (this.state.roomToResidentDetails.details.noticeIssue) {
                const noticeIssueCode =
                    APPLY_STATUS.codeToEnumConstants(
                        this.state.roomToResidentDetails.details.noticeIssue,
                    )
                noticeIssueLabel = noticeIssueCode.label
                if (noticeIssueCode === APPLY_STATUS.APPLYING &&
                    this.state.roomToResidentDetails.details.applicantName) {
                    noticeIssueLabel = noticeIssueLabel +
                        '（申請者：' + this.state.roomToResidentDetails.details.applicantName + '）'
                }
            }
            let noticeIssueCountLabel: number = 0
            if (this.state.roomToResidentDetails.details.noticeIssueCount) {
                noticeIssueCountLabel = this.state.roomToResidentDetails.details.noticeIssueCount
            }

            return (
                <>
                    <Table>
                        <StyledTableCaption>居住者ユーザ情報</StyledTableCaption>
                        <TableBody>
                            <TableRow>
                                <TableRowName>権限</TableRowName>
                                <TableCell colSpan={4}>
                                    {this.state.roomToResidentDetails.details.roleName}
                                </TableCell>
                            </TableRow>
                            {(this.administratorMode === ADMINISTORATOR_MODE.ALL.value) ?
                                <>
                                    <TableRow>
                                        <TableRowName>物件グループ</TableRowName>
                                        <TableCell colSpan={4}>
                                            {this.state.roomToResidentDetails.details.condominiumGroupName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableRowName>物件名</TableRowName>
                                        <TableCell colSpan={4}>
                                            {this.state.roomToResidentDetails.details.condominiumName}
                                        </TableCell>
                                    </TableRow>
                                </> : null
                            }
                            <TableRow>
                                <TableRowName>棟名</TableRowName>
                                <TableCell colSpan={4}>
                                    {this.state.roomToResidentDetails.details.ridgeCd +
                                        ' : ' + this.state.roomToResidentDetails.details.ridgeName}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                {(this.state.selectedCondominiumCardKey === HAVE_OR_NOT.HAVE.value) ?
                                    <>
                                        <TableRowName>部屋番号</TableRowName>
                                        <TableCell colSpan={2}>
                                            {this.state.roomToResidentDetails.details.roomNumber}
                                        </TableCell>
                                        <TableRowName>カードキー番号</TableRowName>
                                        <TableCell colSpan={2}>
                                            {this.state.roomToResidentDetails.details.cardKeyNumber}
                                        </TableCell>
                                    </> :
                                    <>
                                        <TableRowName>部屋番号</TableRowName>
                                        <TableCell colSpan={4}>
                                            {this.state.roomToResidentDetails.details.roomNumber}
                                        </TableCell>
                                    </>
                                }
                            </TableRow>
                            <TableRow>
                                <TableRowName>氏名</TableRowName>
                                <TableCell colSpan={2}>
                                    {getStringOrEmptyString(this.state.roomToResidentDetails.details.familyName)}
                                    {' '}
                                    {getStringOrEmptyString(this.state.roomToResidentDetails.details.firstName)}
                                    {(this.state.roomToResidentDetails.details.familyNameKana ||
                                        this.state.roomToResidentDetails.details.firstNameKana) ?
                                        ' (' + getStringOrEmptyString(
                                            this.state.roomToResidentDetails.details.familyNameKana) +
                                        ' ' + getStringOrEmptyString(
                                            this.state.roomToResidentDetails.details.firstNameKana)
                                        + ')' : ''
                                    }
                                </TableCell>
                                <TableRowName>ステータス</TableRowName>
                                <TableCell colSpan={2}>
                                    {(residentStatusCode !== undefined) ? residentStatusCode.label : ''}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>性別</TableRowName>
                                <TableCell colSpan={2}>
                                    {sexLabel}
                                </TableCell>
                                <TableRowName>生年月日</TableRowName>
                                <TableCell colSpan={2}>
                                    {birthday}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>メールアドレス</TableRowName>
                                <TableCellWordBreakAll colSpan={4}>
                                    {this.state.roomToResidentDetails.details.mailAddressPc}
                                </TableCellWordBreakAll>
                            </TableRow>
                            <TableRow>
                                <TableRowName>管理者確認用氏名</TableRowName>
                                <TableCell colSpan={4}>
                                    {getStringOrEmptyString(this.state.roomToResidentDetails.details.adminFamilyName)}
                                    {' '}
                                    {getStringOrEmptyString(this.state.roomToResidentDetails.details.adminFirstName)}
                                    {(this.state.roomToResidentDetails.details.adminFamilyNameKana ||
                                        this.state.roomToResidentDetails.details.adminFirstNameKana) ?
                                        ' (' + getStringOrEmptyString(
                                            this.state.roomToResidentDetails.details.adminFamilyNameKana) +
                                        ' ' + getStringOrEmptyString(
                                            this.state.roomToResidentDetails.details.adminFirstNameKana)
                                        + ')' : ''
                                    }
                                </TableCell>
                            </TableRow>
                            {this.state.roomToResidentDetails.details.authenticationKey &&
                                <TableRow>
                                    <TableRowName>認証キー</TableRowName>
                                    <TableCell colSpan={4}>
                                        {this.state.roomToResidentDetails.details.authenticationKey}
                                    </TableCell>
                                </TableRow>
                            }
                            {this.state.roomToResidentDetails.details.noticeIssue &&
                                this.state.roomToResidentDetails.details.residentStatus ===
                                RESIDENT_STATUS.UNREGISTERED.value &&
                                <TableRow>
                                    <TableRowName>通知状発行</TableRowName>
                                    <TableCell colSpan={4}>
                                        {noticeIssueLabel}
                                    </TableCell>
                                </TableRow>
                            }
                            {this.state.roomToResidentDetails.details.residentStatus ===
                                RESIDENT_STATUS.UNREGISTERED.value &&
                                <TableRow>
                                    <TableRowName>通知状発行回数</TableRowName>
                                    <TableCell colSpan={4}>
                                        {noticeIssueCountLabel}
                                    </TableCell>
                                </TableRow>
                            }
                            {(this.state.mainUserFlag) ? null :
                                <>
                                    <TableRow>
                                        <TableRowName>メインユーザ</TableRowName>
                                        <TableCell colSpan={4}>
                                            {getStringOrEmptyString(
                                                this.state.roomToResidentDetails.details.parentFamilyName)}
                                            {' '}
                                            {getStringOrEmptyString(
                                                this.state.roomToResidentDetails.details.parentFirstName)}
                                            {(this.state.roomToResidentDetails.details.parentFamilyNameKana ||
                                                this.state.roomToResidentDetails.details.parentFirstNameKana) ?
                                                ' (' + getStringOrEmptyString(
                                                    this.state.roomToResidentDetails.details.parentFamilyNameKana) +
                                                ' ' + getStringOrEmptyString(
                                                    this.state.roomToResidentDetails.details.parentFirstNameKana)
                                                + ')' : ''
                                            }
                                        </TableCell>
                                    </TableRow>
                                </>
                            }
                            <TableRow>
                                <TableRowName>有効期間開始日</TableRowName>
                                <TableCell colSpan={2} width={253}>
                                    {validPeriodStartDate}
                                </TableCell>
                                <TableRowName>有効期間終了日</TableRowName>
                                <TableCell colSpan={2}>
                                    {validPeriodEndDate}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowNameTop rowSpan={3}>メール受信設定</TableRowNameTop>
                                <TableCell colSpan={4}>
                                    ご請求金額の確定通知：{billingAmountFixNoticeLabel}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={4}>
                                    情報交換掲示板のコメント通知：{bulletinBoardCommentNoticeLabel}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={4}>
                                    すてきテラスのメールマガジン：{sutekiNetOfNoticeLabel}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>施設予約可否</TableRowName>
                                <TableCell colSpan={4}>
                                    {facilityReserveAvailabilityLabel}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>メモ</TableRowName>
                                <TableCellWordBreakAll colSpan={4}>
                                    <ExplainText>{this.state.roomToResidentDetails.details.memo}</ExplainText>
                                </TableCellWordBreakAll>
                            </TableRow>
                        </TableBody>
                    </Table>
                </>
            )
        }
    }

    renderPageHeaderArea(): Nullable<ReactNode> {

        if (this.state.roomToResidentDetails.details &&
            this.state.roomToResidentDetails.details.residentStatus !== RESIDENT_STATUS.ABOLITION.value) {
            return (
                <>
                    <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_RESIDENT_USER}>
                        <PageFotterAreaRight>
                            <DeleteLink
                                onClick={this.deleteResidentUser}>
                                居住者ユーザを削除する
                            </DeleteLink>
                        </PageFotterAreaRight>
                    </AuthorityChecker>
                    <PageFotterAreaLeft>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_RESIDENT_USER}>
                            <AdminPrimaryButton
                                disabled={this.state.roomToResidentDetails.details.residentStatus ===
                                    RESIDENT_STATUS.HASEKO_WITHDRAW.value}
                                onClick={this.editResidentUserLinkClick}>
                                編集する
                            </AdminPrimaryButton>
                            <Box ml={'15px'}>
                                <AdminPrimaryButton
                                    disabled={this.state.roomToResidentDetails.details.residentStatus ===
                                        RESIDENT_STATUS.HASEKO_WITHDRAW.value}
                                    onClick={this.editResidentUserForAdminNameLinkClick}>
                                    管理者確認用氏名を編集する
                                </AdminPrimaryButton>
                            </Box>
                            {this.state.roomToResidentDetails.details.residentStatus ===
                                RESIDENT_STATUS.UNREGISTERED.value &&
                                <Box ml={'15px'}>
                                    <AdminPrimaryButton
                                        disabled={this.state.activationButtonDisabled}
                                        onClick={this.activationResidentUser}>
                                        有効化
                                    </AdminPrimaryButton>
                                </Box>
                            }
                        </AuthorityChecker>
                        {this.state.roomToResidentDetails.details.residentStatus ===
                            RESIDENT_STATUS.UNREGISTERED.value &&
                            this.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.value &&
                            <Box ml={'15px'}>
                                <AdminPrimaryButton
                                    disabled={this.state.noticeIssueButtonDisabled}
                                    onClick={this.noticeIssueClick}>
                                    通知状発行
                                </AdminPrimaryButton>
                            </Box>
                        }
                    </PageFotterAreaLeft>
                </>
            )
        } else {
            if (this.state.roomToResidentDetails.details) {
                return <>
                    <PageFotterAreaLeft>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_RESIDENT_USER}>
                            {this.state.roomToResidentDetails.details.abolitionResetAvailability ===
                                AVAILABLE_OR_NOT.AVAILABLE.value &&
                                <AdminPrimaryButton
                                    disabled={false}
                                    onClick={this.onClickAbolitionReset}>
                                    廃止取消
                                </AdminPrimaryButton>
                            }
                        </AuthorityChecker>
                    </PageFotterAreaLeft>
                </>
            }
        }
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink onClick={() => this.props.navigate(this.returnLinkInfo.url)}>
                        {this.returnLinkInfo.label}
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }


    getNoticeIssueDialogComponent(): ReactElement | null {
        if (this.state.authKeyNoticeData && this.state.authKeyNoticeData.details) {
            return (
                <NatPrintDialogComponent
                    open={this.state.noticeIssueOpen}
                    title={'通知状の確認'}
                    errorLevel={Messages.IRESA0015.errorLevel}
                    message={Messages.IRESA0015.toString()}
                    printType={PRINT_TYPE.authKeyNotice}
                    loginUserRoleId={this.loginUserRoleId}
                    isWarn={true}
                    closeDiaLogHandler={this.handleNoticeIssueCancelClick}
                    printExecuteHandler={this.handleNoticeIssuePrintClick}
                    authKeyNoticeParams={{
                        condominiumName: this.state.authKeyNoticeData.details.condominiumName,
                        ridgeName: this.state.authKeyNoticeData.details.ridgeName,
                        roomNumber: this.state.authKeyNoticeData.details.roomNumber,
                        issueDate: this.state.authKeyNoticeData.details.issueDate,
                        authenticationKey: this.state.authKeyNoticeData.details.authenticationKey,
                        firstLoginAccessUrl: this.state.authKeyNoticeData.details.firstLoginAccessUrl,
                    }}
                />
            )
        } else {
            return null
        }
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                {this.getNoticeIssueDialogComponent()}
                <Box mb={'15px'}>
                    <PageFooterArea>
                        {this.renderPageHeaderArea()}
                    </PageFooterArea>
                </Box>
                <Box mb={'15px'}>
                    <NatAdminCommonAcceptedWarningComponent
                        scrollBottom={false}
                        description={'内容をご確認いただき、問題なければチェックしたうえで再度、居住者ユーザ削除リンクを押してください。'}
                        warnings={setHighlightingWarningList(highlightingMessegIdList, this.state.warnings)}
                        changeAcceptedWarnings={this.onChangeAcceptedWarnings}
                        doOpenAnimation={true}
                    />
                </Box>
                <PageMainArea>
                    {this.renderInputFormTable()}
                </PageMainArea>
                {this.administratorMode === ADMINISTORATOR_MODE.CONDOMINIUM.value &&
                    this.state.roomToResidentDetails.details &&
                    this.state.roomToResidentDetails.details.residentStatus !== RESIDENT_STATUS.UNREGISTERED.value &&
                    <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.VIEW_RESERVE_LIST}>
                        <WrapperReservationLink>
                            <StyledLink onClick={this.facilityReservationLinkClick}>予約状況を照会する</StyledLink>
                        </WrapperReservationLink>
                    </AuthorityChecker>
                }
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminResidentUserDetailsPage)

const WrapperReservationLink: StyledDiv = styled.div`
  padding: 15px 0 15px 0;
  text-align: center;
`

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`
const ExplainText: StyledDiv = styled.div`
  white-space: pre-wrap;
`
